import request from '@/utils/request'
import qs from 'qs'

// ************************* 7天签名 ***************************
// 账号管理-账号列表
export const getWeekAccountList = (data: any) =>
  request({
    url: '/singleSign/account',
    method: 'get',
    params: data
  })

// 获取注册限制配置
export const getRegisterConfig = () =>
  request({
    url: '/singleSign/registerConfig',
    method: 'get'
  })

// 修改注册限制配置
export const setRegisterConfig = (data: any) =>
  request({
    url: '/singleSign/registerConfig',
    method: 'post',
    data: qs.stringify(data)
  })

// ************************* 签名信息 ***************************
// 签名信息-签名列表
export const getWeekSignatureList = (data: any) =>
  request({
    url: '/singleSign/signLog',
    method: 'get',
    params: data
  })

// ************************* 7天签应用管理 ***************************
// 7天签应用管理-签名列表
export const getWeekAppList = (data: any) =>
  request({
    url: '/singleSign/advApp',
    method: 'get',
    params: data
  })

// 7天签应用管理-添加7天应用签应用
export const addWeekApp = (data: any) =>
  request({
    url: `/singleSign/advApp`,
    method: 'post',
    data: qs.stringify(data)
  })

// 7天签应用管理-删除应用
export const deleteWeekApp = (id: string) =>
  request({
    url: `/singleSign/advApp/${id}`,
    method: 'delete'
  })

// 拖动排序
export const dragSort = (data: any) =>
  request({
    url: `/singleSign/swapAppSeq`,
    method: 'post',
    data: qs.stringify(data)
  })
